import React from 'react';

import { SVGComponentProps } from './svg.types';

const ItalicSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M9.58889 1C9.58625 0.733868 9.47868 0.479532 9.28955 0.292278C9.10043 0.105024 8.84503 -1.30441e-05 8.57889 1.21501e-09L4.07889 1.21501e-09C3.81274 -1.30441e-05 3.55735 0.105024 3.36822 0.292278C3.1791 0.479532 3.07152 0.733868 3.06889 1V1.463C3.06889 1.73087 3.1753 1.98777 3.36471 2.17718C3.55412 2.36659 3.81102 2.473 4.07889 2.473H5.14489L2.57389 11.526H1.42089C1.15474 11.526 0.899351 11.631 0.710224 11.8183C0.521097 12.0055 0.413524 12.2599 0.410889 12.526V12.989C0.410758 13.1217 0.436785 13.2532 0.487484 13.3758C0.538182 13.4985 0.612557 13.6099 0.706358 13.7038C0.800158 13.7977 0.911544 13.8722 1.03415 13.923C1.15675 13.9738 1.28817 14 1.42089 14H5.99289C6.26024 13.9992 6.51637 13.8924 6.70513 13.7031C6.89389 13.5138 6.99989 13.2573 6.99989 12.99V12.527C6.99725 12.2609 6.88968 12.0065 6.70055 11.8193C6.51143 11.632 6.25603 11.527 5.98989 11.527H4.86089L7.43189 2.474H8.57889C8.84676 2.474 9.10365 2.36759 9.29307 2.17818C9.48248 1.98877 9.58889 1.73187 9.58889 1.464V1Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ItalicSVG;
